import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Activity, SubCompetency } from "@/lib/models";
import Analytics, { ClickActions } from "@/lib/analytics";
import { Accordion } from "@heathmont/moon-core-tw";
import ChevronDown from "../icons/ChevronDown";
import ArrowRight from "../icons/ArrowRight";

type ComponentSkillActivitySectionProps = {
  componentSkill: SubCompetency;
};

export const ComponentSkillActivitySection = ({
  componentSkill,
}: ComponentSkillActivitySectionProps) => {
  const [isActivityOpen, setIsActivityOpen] = useState(true);

  const onAccordionChange = () => {
    const clickActionType = isActivityOpen
      ? ClickActions.Collapse
      : ClickActions.Expand;
    Analytics.handleComponentSkillActivitySectionEvent(
      componentSkill,
      clickActionType,
    );
    setIsActivityOpen(!isActivityOpen);
  };

  const handleActivityTileClick = (activity: Activity) => {
    Analytics.handleActivityTileClick({
      activity,
    });
  };

  return (
    <Accordion
      className="border-t border-tab-border pl-6 pt-5"
      onValueChange={onAccordionChange}
      defaultValue={componentSkill!.id}
    >
      <Accordion.Item value={componentSkill!.id}>
        <Accordion.Header className="flex items-center pb-5">
          <p className="font-roobert text-base font-semibold">
            Related Activities
          </p>
          <Accordion.Button className="mr-2.5 w-auto flex-none rounded-[100px] !p-1 hover:bg-tab-bg-hover active:bg-tab-bg-press [&[data-state=open]>span]:rotate-180">
            <span aria-hidden="true" aria-label="Toggle Related Activities">
              <ChevronDown className={`transition duration-200`} />
            </span>
          </Accordion.Button>
        </Accordion.Header>
        <Accordion.Content className="flex-wrap overflow-hidden !p-0 data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown">
          {componentSkill.activities.map((activity) => {
            return (
              <div key={activity.name} className="mb-4 small:mr-4 ">
                <Link
                  href={`/activities/${activity.urlSlug}`}
                  onClick={() => handleActivityTileClick(activity)}
                  shallow={true}
                  aria-label={activity.name}
                >
                  <div className="flex h-16 w-[278px] items-center overflow-hidden rounded-lg border border-tab-border">
                    <Image
                      src={activity.activityCard.sourceUrl!}
                      alt={activity.name}
                      width={114}
                      height={64}
                    />
                    <span className="px-4 text-base font-semibold leading-none">
                      {activity.name}
                    </span>
                    <ArrowRight className="mr-4 h-6 w-9" fill="#145758" />
                  </div>
                </Link>
              </div>
            );
          })}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  );
};
